import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { gradient, greys } from "@clockwise/web-commons/src/styles/color.styles";
import { styles as mainStyles } from "../AutopilotStatus.styles";

const container: CSSProperties = {
  background: gradient,
  backgroundColor: gradient,
  border: "none",

  "&:hover, &.actionable:hover": {
    background: gradient,
    backgroundColor: gradient,
  },

  "&:active, &.actionable:active": {
    background: gradient,
    backgroundColor: gradient,
  },
};

export const status: CSSProperties = {
  ...mainStyles.status,
  color: greys.white,
};

export const description: CSSProperties = {
  ...mainStyles.description,
  color: greys.white,
};

export const styles = {
  container,
  status,
  description,
};
